import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "Lib/API/Auth";
import { toastr } from "react-redux-toastr";

const initialState = {
  collectionDisplayName: "",
  fieldsGroup: {},
  filterTable: [],
  filterTotalCount: 0,
  filterLoading: false,
  search: "parameter",
  orderFieldType: "order-fields",
  selectedAddress: "active-address",
};

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (args, { thunkAPI, getState }) => {

    const { token, data } = args;
    const { filterParams } = getState();
    const parameterValues = filterParams?.fieldsGroup;
    const orderValues = filterParams?.fieldsOrder || data?.filters;

    const data_to_send = {
      filterName: data?.filterName || "",
      pagination: args?.pagination || { items_per_page: 25, current_page: 1 },
      sort: args?.sort || {},
      selectedFields: Object.keys(parameterValues).map((key) => {
        const mainArray = parameterValues[key].values;
        const lineIndex = 0;
        const lineContainsArray = (mainArray === null || mainArray === undefined) ? true : Array.isArray(mainArray[lineIndex]);

        const hasComma = parameterValues[key].values?.includes(',');

        return {
          fieldName: key,
          operator: parameterValues[key].operator,
          type: parameterValues[key].oprInputType,
          displayName: parameterValues[key].displayName,
          fieldValue: lineContainsArray
            ? parameterValues[key].values?.[0] === null ? "" : parameterValues[key].values?.[0]
            : parameterValues[key].values === null ? ""
            : parameterValues[key].operator === 10 && typeof parameterValues[key]?.values === "string" ? parameterValues[key]?.values?.split(",")
              : parameterValues[key].operator === 7 || parameterValues[key].operator === 8 ?
                hasComma ? parameterValues[key]?.values?.split(' , ') : [parameterValues[key].values] :
                parameterValues[key].values || [],
          collectionName: parameterValues[key]?.collectionName || "",
        };
      }),

      selectedFieldsOrder: orderValues.map(
        ({ collectionName, fieldName }, index) => {
          return {
            collectionName,
            fieldName,
            order: index + 1,
          };
        }
      ),
    };

    try {
      const response = await AuthService.sendFilterParams(data_to_send, token);
      return response;
    } catch (error) {
      console.error('Error occurred:', error);
      toastr.error("Error", error?.data?.message)
      // Handle the error accordingly (e.g., display an error message)
    }

    // const response = await AuthService.sendFilterParams(data_to_send, token);
    // return response;
  }
);

export const getFilterData = createAsyncThunk(
  "getFilterData",
  async (args) => {
    const { token, id, pagination, sort } = args;

    if (pagination) {
      const filterDef = await AuthService.getFilterById(id, token);
      const data_to_send = {
        selectedFields: filterDef?.selectedFields || [],
        selectedFieldsOrder: filterDef?.selectedFieldsOrder || [],
        pagination,
        sort: sort || {},
      };
      const response = await AuthService.sendFilterParams(data_to_send, token);
      return response;
    }

    const response = await AuthService.getMyFilterParams(id, token);
    return response;
  }
);

export const filterParams = createSlice({
  name: "filterParams",
  initialState,
  reducers: {
    collectionDisplayName: (state, action) => {
      state.collectionDisplayName = action.payload;
      return state;
    },
    filterParameters: (state, action) => {
      state.fieldsGroup = action.payload;
      return state;
    },
    filterOrder: (state, action) => {
      state.fieldsOrder = action.payload;
      return state;
    },
    filterState: (state, action) => {
      state.search = action.payload;
    },
    filterState: (state, action) => {
      state.search = action.payload;
    },
    filterMailingFields: (state, action) => {
      state.mailingFields = action.payload;
    },
    filterOrderFieldType: (state, action) => {
      state.orderFieldType = action.payload;
    },
    filterSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    clearFilterTable: (state) => {
      state.filterTable = [];
    },
    reset: (state) => initialState,
  },
  extraReducers: {
    [fetchProducts.pending]: (state) => {
      state.filterLoading = true;
    },
    [fetchProducts.fulfilled]: (state, action) => {
      state.filterLoading = false;
      const payload = action?.payload;
      state.filterTable = payload?.payload?.data ?? payload?.data ?? payload ?? [];
      state.filterTotalCount = payload?.payload?.pagination?.count ?? payload?.pagination?.count ?? (Array.isArray(payload) ? payload.length : 0);
    },
    [fetchProducts.rejected]: (state) => {
      state.filterLoading = false;
    },
    [getFilterData.pending]: (state) => {
      state.filterLoading = true;
    },
    [getFilterData.fulfilled]: (state, action) => {
      state.filterLoading = false;
      const payload = action?.payload;
      state.filterTable = payload?.payload?.data ?? payload?.data ?? payload ?? [];
      state.filterTotalCount = payload?.payload?.pagination?.count ?? payload?.pagination?.count ?? (Array.isArray(payload) ? payload.length : 0);
    },
    [getFilterData.rejected]: (state) => {
      state.filterLoading = false;
    },
  },
});

export const {
  filterParameters,
  filterOrder,
  reset,
  filterState,
  collectionDisplayName,
  filterMailingFields,
  filterOrderFieldType,
  filterSelectedAddress,
  clearFilterTable,
} = filterParams.actions;

export default filterParams.reducer;
